import React from 'react';
import Orders from '../../components/Orders';

const OrdersPage = ({ classes, history }) => {
  return (
    <div className='orders-table-wrap'>
      <div className={classes.wrap}>
        <Orders onView={() => {
          history.push('orders/10')}
        }/>
      </div>
    </div>
  );
};

export default OrdersPage;
